





















































import { computed, defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { FormField } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";
import BaseInput from "@/components/BaseInput";
import BaseInputTextarea from "@/components/BaseInputTextarea";
import BaseTooltip from "@/components/BaseTooltip";

export default defineComponent({
  name: "VaultCreateCategoryModal",
  components: {
    BaseButton,
    BaseTooltip,
    BaseInputTextarea,
    BaseCheckbox,
    BaseInput,
    BaseForm,
    BaseConfirm,
  },
  props: {
    value: { type: Boolean, required: true },
    allowAi: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const { authUserStrict } = useAuthUser();
    const loading = ref(false);
    const inputProps = ref<FormField>({
      placeholder: $t("New category"),
      name: "categoryName",
      autofocus: true,
      rules: ["required"],
      class: "mb-5",
      rulesMessages: {
        required: $t("This field is required"),
      },
      autocomplete: "off",
    });

    const values = ref({
      categoryName: "",
      isAiCategory: false,
      keywords: "",
    });
    const isValid = computed(
      () =>
        !!values.value.categoryName.trim() &&
        (!values.value.isAiCategory || (values.value.isAiCategory && !!values.value.keywords.trim()))
    );

    const clearInput = () => {
      values.value.categoryName = "";
      values.value.keywords = "";
      values.value.isAiCategory = false;
    };

    const onCreated = async () => {
      if (!isValid.value) return;
      try {
        loading.value = true;
        const newCategory = await providers.VaultsProvider.createCategory({
          data: {
            name: values.value.categoryName.trim(),
            userId: authUserStrict.value.id,
            ai: values.value.isAiCategory,
            keywords: values.value.keywords.trim(),
          },
        });
        emit("create", newCategory);
        emit("close");
        clearInput();
      } finally {
        loading.value = false;
      }
    };

    return {
      isValid,
      loading,
      values,
      inputProps,
      onCreated,
    };
  },
});
